import { render, staticRenderFns } from "./list_add.vue?vue&type=template&id=986b394a&scoped=true"
import script from "./list_add.vue?vue&type=script&lang=js"
export * from "./list_add.vue?vue&type=script&lang=js"
import style0 from "./list_add.vue?vue&type=style&index=0&id=986b394a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986b394a",
  null
  
)

export default component.exports